import { Nullable } from './common';

export enum Kind {
  Pharmacy = 'pharmacy',
}

export interface Geometry {
  longitude: number;
  latitude: number;
}

export interface PlaceSuggestion {
  mainText: string;
  secondaryText: string;
  placeId: string;
}

export interface BasePlaceDetail {
  addressOne: string;
  addressTwo: string;
  city: string;
  state: string;
  zipCode: string;
}

export interface PlaceDetails extends Nullable<Geometry>, BasePlaceDetail {}
